module.exports = __webpack_public_path__ + "static/img/head_3.627925c1.png";